import {
  SET_STRIPE_COUPON,
  SET_STRIPE_INCORRECT_COUPON,
} from "../actions/actionsTypes";

const initialState = {
  coupon: {},
  couponStatus: true,
};

export const stripeReducer = (state = initialState, action) => {
  if (action.type === SET_STRIPE_COUPON) {
    const couponData = action.payload;
    return { ...state, coupon: couponData };
  }

  if (action.type === SET_STRIPE_INCORRECT_COUPON) {
    return { ...state, couponStatus: action.payload };
  }

  return state;
};
